import { IconButton } from '@chakra-ui/react'
import { Pencil } from 'components/Toolkit'
import { LedgerItem } from 'lib/ledger'
import React, { FC, useState } from 'react'
import { EditLedgerItemModal } from './EditModal'

interface EditButtonProps {
  ledgerItem: LedgerItem
  rentalId: string
  blockedEditMessage?: string | null
  onSuccess?: () => void | Promise<void>
}
export const EditButton: FC<React.PropsWithChildren<EditButtonProps>> = ({
  rentalId,
  ledgerItem,
  blockedEditMessage = null,
  onSuccess
}) => {
  const [isOpen, setIsOpen] = useState(false)

  if (ledgerItem.type === 'Payment') {
    return null
  }
  return (
    <>
      <IconButton
        h='28px'
        minW='28px'
        variant='ghost'
        disabled={isOpen}
        aria-label={`Edit ${ledgerItem.type}`}
        icon={<Pencil />}
        onClick={() => setIsOpen(true)}
      />
      <EditLedgerItemModal
        ledgerItem={ledgerItem}
        rentalId={rentalId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSuccess={onSuccess}
        blockedEditMessage={blockedEditMessage}
      />
    </>
  )
}
